import Configuration from '@/agilis/util/Configuration'
import DashboardTable from '@/agilis/components/Dashboard/DashboardTable/DashboardTable'
import { mapGetters } from 'vuex'

export default {
  name: 'TrackerDashboardTable',
  props: {
    configuration: Object
  },

  mixins: [DashboardTable],

  computed: {
    ...mapGetters({
      'applicationId': 'contextStore/applicationId',
      'trackerTypeId': 'contextStore/trackerTypeId',
      'workspaceId': 'contextStore/workspaceId'
    }),

    datatable () {
      return () => {
        return Configuration.datatable.getDatatable({
          applicationId: this.applicationId,
          trackerTypeId: this.trackerTypeId,
          workspaceId: this.workspaceId
        })
      }
    },

    headers () {
      if (this.result) {
        return Configuration.datatable.getHeaders(this.configuration).filter(head => head.value !== 'actions')
      }
    }
  },

  methods: {
    renderColumn (colId, item) {
      const colConfig = this.configuration.columns[colId]
      return Configuration.datatable.renderColumn(colConfig, item)
    }
  }
}
